import { IBaseClass, BaseClass } from '../base';
import firebaseApp from '../../../services/firebaseService';

export interface IBoreholeIssue extends IBaseClass {
    name : string;
}

export default class BoreholeIssue extends BaseClass implements IBoreholeIssue {
    public static COLLECTION = 'borehole_issues';
    public name : string;

    constructor(snapshot ?: firebase.firestore.DocumentSnapshot | firebase.firestore.QueryDocumentSnapshot) {
        super(snapshot);
        if (snapshot && snapshot.exists) {
            const data = snapshot.data();

            if (data) {
                this.name = data['name'];
            }
        }
    }

    protected toObject() {
        const obj = {
            ...this,
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { ref, ...rest } = obj;

        return rest;
    }

    public save() {
        if (this.ref) {
            return firebaseApp.firestore().doc(this.ref.path).set(this.toObject(), {
                merge: true,
            });
        } else {
            return firebaseApp.firestore().collection(BoreholeIssue.COLLECTION).add(this.toObject());
        }
    }

    public async delete() {
        if (this.ref) {
            return firebaseApp.firestore().doc(this.ref.path).delete();
        }

        return null;
    }
}
